import React from 'react'
import { Result, Button } from 'antd'
import { useHistory } from 'react-router-dom'
import { useAppDispatch } from '~/Store/hooks'
import { UserActions } from '~/Store/User'

export const Unauthorized = () => {
  const history = useHistory()
  const dispatch = useAppDispatch()

  const handleBackToLogin = () => {
    dispatch(UserActions.logout())
    history.push('/login')
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100vw',
      }}
    >
      <Result
        status="403"
        title="403"
        subTitle="You do not have permission to access this application. Please contact your administrator."
        extra={
          <Button type="primary" onClick={handleBackToLogin}>
            Back to Login
          </Button>
        }
      />
    </div>
  )
}
